<template>
	<div class="login-view">
		<div class="login-main">
			<div class="login-box">
				<div class="title-section">
					<h1 class="login-title">账号登录</h1>
				</div>
				
				<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
					@keyup.enter.native="submitForm('loginForm')">
					<el-form-item prop="userName" class="form-item">
						<div class="input-wrapper">
							<el-input type="text" v-model="loginForm.userName" autocomplete="off" placeholder="手机号/账号" class="wechat-input" :validate-event="false">
							</el-input>
						</div>
					</el-form-item>
					<el-form-item prop="password" class="form-item">
						<div class="input-wrapper">
							<el-input :type="showPassword ? 'text' : 'password'" v-model="loginForm.password" autocomplete="new-password" placeholder="密码" class="wechat-input password-input" :validate-event="false">
							</el-input>
							<span class="password-toggle" @click="togglePassword">
								<i :class="showPassword ? 'el-icon-eye' : 'el-icon-eye-off'"></i>
							</span>
						</div>
					</el-form-item>
					
					<el-form-item class="forgot-password">
						<a href="javascript:void(0)" class="forgot-link">忘记密码</a>
					</el-form-item>
					<el-button class="submit-btn" type="primary" @click="submitForm('loginForm')">登录</el-button>
				</el-form>
				
				<div class="register-link">
					没有账号？<span class="register-btn" @click="handleRegister">立即注册</span>
				</div>
			</div>
			
			<div class="login-copyright">{{ copyright }}</div>
		</div>
	</div>
</template>

<script>
import userStore from '../store/userStore';
export default {
	name: "login",
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入账号'));
			}
			if (!/^\d+$/.test(value)) {
				return callback(new Error('账号必须为纯数字'));
			}
			if (value.length < 5) {
				return callback(new Error('账号最少5位数字'));
			}
			if (value.length > 11) {
				return callback(new Error('账号最多11位数字'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			if (value.length < 6) {
				callback(new Error('密码最少6位'));
			}
			callback();
		};
		return {
			userStore: userStore(),
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: ''
			},
			isAutoLogin: true,
			showPassword: false,
			copyright: '© 2026 叨叨|内部技术研究测试专用',
			allowRegister: false,
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	mounted() {
		this.loginForm.userName = this.getCookie("username");
		this.loginForm.password = this.getCookie("password");
		if (localStorage.getItem("isAutoLogin") != null) {
			this.isAutoLogin = JSON.parse(localStorage.getItem("isAutoLogin"));
			this.loginForm.userName = localStorage.getItem("username") || this.loginForm.userName;
			this.loginForm.password = localStorage.getItem("password") || this.loginForm.password;
			if (this.isAutoLogin && this.loginForm.userName && this.loginForm.password) {
				this.submitForm('loginForm');
			}
		}
		this.loadSystemConfig();
	},
	methods: {
		togglePassword() {
			this.showPassword = !this.showPassword;
		},
		loadSystemConfig() {
			this.$http({
				url: "/admin/system/config/list",
				method: 'get'
			}).then((response) => {
				if (response) {
					const configMap = {};
					response.forEach(item => {
						const key = item.configKey || item.key;
						const value = item.configValue || item.value;
						configMap[key] = value;
					});
					this.allowRegister = configMap['register_enabled'] === 'true';
				}
			}).catch(() => {
				this.allowRegister = false;
			});
		},
		handleRegister() {
			if (this.allowRegister) {
				this.$router.push('/register');
			} else {
				this.$message.error('当前系统已关闭新用户注册功能');
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					})
						.then((data) => {
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							localStorage.setItem('isAutoLogin', this.isAutoLogin);
							localStorage.setItem('username', this.loginForm.userName);
							localStorage.setItem('password', this.loginForm.password);
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);
							this.userStore.loadUser().then(() => {
								this.$message.success("登录成功");
								this.$router.push("/home/chat");
							});
						})
				}
			});
		},
		getCookie(name) {
			let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			let arr = document.cookie.match(reg)
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		}
	}
}
</script>

<style scoped lang="scss">
.login-view {
	width: 100%;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f9fafb;
	font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.login-main {
	width: 100%;
	max-width: 440px;
	padding: 20px;
}

.login-box {
	background: #ffffff;
	border-radius: 20px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	border: 1px solid #f0f0f0;
	padding: 40px;
}

.title-section {
	text-align: center;
	margin-bottom: 40px;
	
	.login-title {
		font-size: 28px;
		font-weight: 700;
		color: #1f2937;
		margin: 0;
	}
}

.form {
	.form-item {
		margin-bottom: 24px;
		width: 85%;
		margin-left: auto;
		margin-right: auto;
		
		&:last-of-type {
			margin-bottom: 0;
		}
	}
	
	.input-wrapper {
		position: relative;
		text-align: center;
	}
	
	.wechat-input {
		width: 100%;
		
		::v-deep .el-input {
			display: inline-block;
			text-align: center;
		}
		
		::v-deep .el-input__inner {
			width: 100% !important;
			height: auto !important;
			line-height: normal !important;
			border: none !important;
			border-bottom: 1px solid #e5e7eb !important;
			border-radius: 0 !important;
			padding: 12px 0 !important;
			font-size: 18px !important;
			color: #1f2937 !important;
			background: transparent !important;
			outline: none !important;
			transition: all 0.3s !important;
			box-shadow: none !important;
			text-align: center !important;
			
			&:focus {
				border-color: #07c160 !important;
				box-shadow: none !important;
			}
			
			&::placeholder {
				color: #9ca3af !important;
				font-size: 18px !important;
			}
		}
	}
	
	.password-input {
		::v-deep .el-input__inner {
			padding-right: 48px !important;
		}
	}
	
	.password-toggle {
		position: absolute;
		right: 8px;
		top: 50%;
		transform: translateY(-50%);
		background: none;
		border: none;
		cursor: pointer;
		color: #9ca3af;
		font-size: 18px;
		transition: color 0.3s;
		z-index: 10;
		
		&:hover {
			color: #07c160;
		}
	}
	
	.forgot-password {
		text-align: right;
		margin-bottom: 32px;
		
		.forgot-link {
			font-size: 14px;
			color: #6b7280;
			text-decoration: none;
			transition: color 0.3s;
			
			&:hover {
				color: #07c160;
			}
		}
	}
	
	.submit-btn {
		width: 100%;
		height: 44px;
		border-radius: 22px;
		background: #07c160;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
		border: none;
		box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
		transition: all 0.3s;
		
		&:hover {
			background: #06ae56;
			box-shadow: 0 4px 16px rgba(7, 193, 96, 0.4);
		}
		
		&:active {
			transform: scale(0.98);
		}
	}
}

.register-link {
	text-align: center;
	margin-top: 32px;
	font-size: 14px;
	color: #6b7280;
	
	.register-btn {
		color: #07c160;
		font-weight: 500;
		cursor: pointer;
		transition: text-decoration 0.3s;
		
		&:hover {
			text-decoration: underline;
		}
	}
}

.login-copyright {
	text-align: center;
	font-size: 12px;
	color: #9ca3af;
	margin-top: 40px;
}

@media screen and (max-width: 768px) {
	.login-box {
		padding: 30px 20px;
		border-radius: 16px;
	}
	
	.title-section {
		margin-bottom: 30px;
		
		.login-title {
			font-size: 24px;
		}
	}
	
	.form {
		.form-item {
			margin-bottom: 20px;
		}
		
		.wechat-input {
			.el-input__inner {
				height: 48px;
				line-height: 48px;
				font-size: 16px;
			}
		}
		
		.submit-btn {
			height: 42px;
			font-size: 15px;
			margin-top: 24px;
		}
	}
	
	.register-link {
		margin-top: 28px;
	}
	
	.login-copyright {
		margin-top: 30px;
		font-size: 11px;
	}
}
</style>